import { connect } from 'react-redux';
import { search, restrictToLawyer } from '../../../../state/actions';
import { LawyerItemType } from '../searchAutocomplete.types';

const mapDispatch = (
  dispatch: Function,
  { item, label }: { item: LawyerItemType; label: string },
) => ({
  showLawyerDecisions() {
    dispatch(
      restrictToLawyer({
        lawyerId: item.metadata.lawyer_id,
        lawyerName: label,
      }),
    );
    dispatch(search({ reason: 'autocomplete_click' }));
  },
});

export const Connect = connect(null, mapDispatch);
